import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledDemographicsContainer = styled(Box, {
  display: 'flex',
  gap: '$6',
  justifyContent: 'flex-start',
});

export const StyledLeftContainer = styled(Box, {
  width: '-webkit-fill-available',
});

export const StyledRightContainer = styled(Box, {
  width: '-webkit-fill-available',
});
